import { connect } from 'react-redux';

import AddHazardManagementLogDialog from '../../components/AddHazardManagementLogDialog';
import {
  openAddHazardManagementLogDialogDispatch,
  handleAddHazardManagementLogInputChangeDispatch,
  submitHazardManagementLogDispatch,
  removeHazardManagementLogsAttachment
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.hazard.newManagementLog.openAddHazardManagementDialog,
    isSaving: state.hazard.newManagementLog.isSaving,
    managementLog: state.hazard.newManagementLog.item,
    hazard: state.hazard.newHazard.item,
    allAttachments: state.hazard.newManagementLog.item.attachmentFiles,
    branchId: state.branch.branch.item && state.branch.branch.item.id
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenAddHazardManagementDialog: (open) => {
      dispatch(openAddHazardManagementLogDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(
        handleAddHazardManagementLogInputChangeDispatch(value, inputFieldName)
      );
    },
    submitManagementLog: (payload, mode, branchId) => {
      dispatch(submitHazardManagementLogDispatch(payload, mode, branchId));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeHazardManagementLogsAttachment(attachment));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddHazardManagementLogDialog);
